module.exports = __webpack_public_path__ + "./Nine_pbw_23f85e3019a479d013d25d7ab833e460.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Nine_pbw.png
// module id = 603
// module chunks = 0